export default {
      id: "help-blue-usage",
      viewBox: "0 0 25 25",
      url: "images/" + "sprite.svg#help-blue-usage",
      toString: function () {
        return this.url;
      }
    }